<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-lm-title">
      {{$t('maintenance.log_management.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-lm-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-lm-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-lm-name-label">
                  {{ $t('maintenance.log_management.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-lm-form-name"
                  type="text"
                  v-model="lmForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.log_management.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-lm-collection-label">
                  {{ $t('maintenance.log_management.create.log_collection_label') }}
                </label>
                <b-form-radio-group
                  v-model="lmForm.log_collection"
                  :options="radioOptions"
                  qid="create-lm-form-collection"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <label qid="create-lm-analysis-label">
                  {{ $t('maintenance.log_management.create.log_analysis_label') }}
                </label>
                <b-form-radio-group
                  v-model="lmForm.log_analysis"
                  :options="radioOptions"
                  qid="create-lm-form-analysis"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-lm-cancel-button"
              >
                {{ $t('maintenance.log_management.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-lm-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.log_management.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateLogManagement',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.log_management.title'),
            to: '/maintenance/log-management'
          },
          {
            text: this.$t('maintenance.log_management.create.title'),
            active: true
          }
        ],
        lmForm: {
          name: '',
          log_collection: '',
          log_analysis: '',
          client:'',
        },
        error: '',
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/log-management')
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.lmForm.name);
        formData.append("log_collection", this.lmForm.log_collection);
        formData.append("log_analysis", this.lmForm.log_analysis);
        formData.append("client", this.getClient.slug);

        // Post FormData object to API
        piincHttp.post('/log-managements', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.log_management.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            // Print whole array of actual errors beside message
            self.error = self.error + '\n\n' + JSON.stringify(error.data.errors);
          }
        })
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
